/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import initialState from 'store/initialState';

export const clientsSlice = createSlice({
  name: 'clients',
  initialState: initialState.clients,
  reducers: {
    initCollections: (state) => {
      state.collections.data = null;
      state.collections.loading = true;
      state.collections.error = '';
      state.collections.loaded = false;
    },
    errorCollections: (state, action) => {
      state.collections.error = action.payload;
      state.collections.loaded = false;
      state.collections.loading = false;
    },
    successCollections: (state, action) => {
      state.collections.data = action.payload;
      state.collections.loaded = true;
      state.collections.loading = false;
    },
    clearCollections: (state) => {
      state.collections.data = null;
      state.collections.error = '';
      state.collections.loaded = false;
      state.collections.loading = false;
    },
  },
});

export const clientsActions = clientsSlice.actions;

export default clientsSlice.reducer;
